<mui-form-field
  [label]="label()"
  [labelId]="labelId()"
  [labelFor]="inputId()"
  [required]="required()"
  class="has--trailing-icon">

  @if (!isMobile()) {
    <div
      #select
      class="mui-input__control mui-input__select"
      role="combobox"
      aria-haspopup="listbox"
      [id]="id()"
      [attr.aria-expanded]="isOpen()"
      [attr.aria-disabled]="disabled()"
      [attr.aria-labelledby]="labelId() + ' ' + id()"
      [attr.name]="name()"
      [class.has--value]="multi() ? multiModel.length > 0 : model"
      [class.has--content]="multi() ? multiModel.length > 0 : model"
      [class.has--error]="!valid"
      [class.is--disabled]="disabled()"
      [class.has--placeholder]="placeholder()"
      (mousedown)="mouseDown = true"
      (mouseup)="mouseDown = false"
      (focus)="open()"
      (click)="toggleDropdown()"
      (keydown.enter)="$event.preventDefault(); toggleDropdown()"
      (keydown.space)="$event.preventDefault(); toggleDropdown()"
      (keydown.escape)="handleEscapeKey()"
      (keydown.arrowDown)="$event.preventDefault(); focusOption(0)"
      (keydown.arrowUp)="$event.preventDefault(); focusOption(optionElements.length - 1)"
      [tabindex]="disabled() ? '-1' : '0'">
      <input
        aria-hidden="true"
        hidden
        [id]="inputId()"
        [attr.name]="name()"
        [value]="getCurrentStringValue()"
        [attr.aria-required]="required() ?? false"
        [attr.aria-labelledby]="labelId()"
        [attr.aria-invalid]="_control?.invalid ?? null">
      <div class="mui-select__value">
        @if (!multi() && model) {
          <ng-container
            [ngTemplateOutlet]="valueTemplate() || defaultTemplate"
            [ngTemplateOutletContext]="{ $implicit: model, context: model.context }"></ng-container>
        }

        @if (multi() && multiModel.length) {
          <ng-container
            [ngTemplateOutlet]="valueTemplate() || defaultMultiTemplate"
            [ngTemplateOutletContext]="{ $implicit: multiModel }"></ng-container>
        }

        @if (!model && !multiModel.length) {
          {{ placeholder() }}
        }
      </div>
    </div>
  } @else {
    <!-- Used for the native select on mobile devices -->
    <select
      muiInput
      [id]="inputId()"
      [name]="name()"
      [multiple]="multi() ? 'true' : null"
      (change)="nativeSelectOption($event)"
      [class.has--content]="multi() || model"
      [class.has--placeholder]="placeholder() && !model && !multiModel.length">

      @if (placeholder() && !multi()) {
        <option [value]="undefined" disabled [selected]="!model && !multiModel.length">
          {{ placeholder() }}
        </option>
      }
      @for (option of options; track option.value) {
        <option
          [value]="option.value"
          [label]="option.label"
          [disabled]="option.disabled"
          [selected]="isSelectedOption(option)">
          {{ option.label }}
        </option>
      }
    </select>
  }

  @if (!isMobile()) {
    <div class="mui-input__trailing mui-input__trailing-icon" aria-hidden="true">
      <i mui-icon name="chevron-down" font="fa" class="mui-input__trailing__chevron fa-fw"></i>
    </div>
  }
  <ng-content></ng-content>
</mui-form-field>

<ng-template #overlayTemplate>
  <ul
    #optionList
    role="listbox"
    tabindex="-1"
    class="mui-select__option-container"
    [attr.aria-labelledby]="labelId()"
    [attr.aria-multiselectable]="multi()"
    [attr.aria-activedescendant]="getActiveDescendantId()"
    [cdkTrapFocus]="optionsFocusable">
    @for (option of options; track option.value; let i = $index) {
      <li
        #options role="option"
        class="mui-select__option"
        [id]="getOptionId(i)"
        (click)="onOptionClick($event, option)"
        (mouseenter)="focusOption(i)"
        (keydown.enter)="$event.preventDefault(); selectOption(option)"
        (keydown.space)="$event.preventDefault(); selectOption(option)"
        (keydown.escape)="close()"
        (keydown.arrowUp)="onOptionArrowUp($event, options)"
        (keydown.arrowDown)="onOptionArrowDown($event, options)"
        [class.disabled]="option.disabled"
        [tabindex]="optionsFocusable && !option.disabled ? 0 : -1"
        [attr.aria-disabled]="option.disabled"
        [attr.aria-selected]="isSelectedOption(option)">

        <div class="mui-select__option-label">
          <ng-container [ngTemplateOutlet]="option.template"></ng-container>
        </div>

        @if (!multi() && isSelectedOption(option)) {
          <i
            mui-icon name="check" font="fa"
            class="fa-fw mui-select__option-checked-icon"></i>
        }

        @if (multi()) {
          <mui-checkbox
            [ngModel]="isSelectedOption(option)"
            [disabled]="option.disabled"
            tabindex="-1"
            ngDefaultControl
            class="mui-select__option-checkbox"></mui-checkbox>
        }
      </li>
    }
  </ul>
</ng-template>

<ng-template #defaultTemplate let-o>
  {{ o.label }}
</ng-template>

<ng-template #defaultMultiTemplate let-opts>
  {{ getMultiValueDefaultString(opts) }}
</ng-template>
